import { imageSrc, sectionOf, type PostSummary } from "@/lib/site";

// The article's own photo, or a quiet neutral tile (never another article's or another season's photo).
export function CardImage({ post, className = "" }: { post: PostSummary; className?: string }) {
  if (post.image) {
    return <img src={imageSrc(post.image)} alt={post.title} loading="lazy" className={`h-full w-full object-cover transition-transform duration-700 group-hover:scale-[1.03] ${className}`} />;
  }
  const s = sectionOf(post.section);
  return (
    <div className={`flex h-full w-full items-center justify-center bg-[#F5F5F4] ${className}`} data-testid={`card-placeholder-${post.slug}`}>
      <span className={post.section === "kids" ? "hand-note text-3xl" : "shop-eyebrow"}>{s?.short || "handmade"}</span>
    </div>
  );
}
